import { gql, TypedDocumentNode } from "@apollo/client";

import {
  AuthorizationScheme,
  Maybe,
  OAuthRedirect,
  SlackAppConfig,
  SlackIntegration,
} from "types/generated";

type SettingsSlackIntegration = Maybe<Pick<SlackIntegration, "teamName" | "teamID">>;
export type SettingsSlackAppConfig = Maybe<Pick<SlackAppConfig, "clientId" | "canUpdate">>;

type FetchGetAccountIntegrations = {
  authorizationScheme: AuthorizationScheme;
  slackIntegration: SettingsSlackIntegration;
  slackAppConfig: SettingsSlackAppConfig;
};

export const GET_ACCOUNT_INTEGRATIONS: TypedDocumentNode<FetchGetAccountIntegrations> = gql`
  query GetAccountIntegrations($isSelfHosted: Boolean!) {
    authorizationScheme
    slackIntegration {
      teamName
      teamID
    }
    slackAppConfig @include(if: $isSelfHosted) {
      clientId
      canUpdate
    }
  }
`;

type FetchSlackOauthRedirect = {
  slackOauthRedirect: Pick<OAuthRedirect, "providerUrl" | "temporaryToken">;
};
export const SLACK_OAUTH_REDIRECT: TypedDocumentNode<FetchSlackOauthRedirect> = gql`
  mutation SlackOauthRedirect {
    slackOauthRedirect {
      providerUrl
      temporaryToken
    }
  }
`;
